<!-- ============ PRODUCT MODAL =========== -->
<div class="product" *ngIf="isModal">
  <div class="product__backdrop" (click)="closeModal()" (touchmove)="$event.preventDefault();"></div>
  <div class="product-container">
    <!-- ============ HEADER =========== -->
    <ng-container *ngTemplateOutlet="cardHeader"></ng-container>
    <!-- ============ BODY =========== -->
    <ng-container *ngTemplateOutlet="cardBody"></ng-container>
    <!-- ============ FOOTER =========== -->
    <ng-container *ngTemplateOutlet="cardFooter"></ng-container>
    <ng-container>
      <div class="throttling-wrap" *ngIf="restaurant.isOrderThrottling && chosenVariation?.throttlingEstimation">
        <span class="material-icons icon-color">warning</span>
        Wait time for this item is longer than usual (Estimated &nbsp;<strong>{{chosenVariation?.throttlingEstimation}}</strong>)
      </div>
    </ng-container>
  </div>
</div>

<!-- ============ PRODUCT CARD =========== -->
<div id="close-modal-x" (click)="closeModal()" class="header-close" *ngIf="!isModal">
  <svg slot="icon-only" class="header-close-icon" aria-label="Close">
    <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
  </svg>
</div>
<div class="closed-zone" [class.closed-zone-image-enlarged]="enlargedImages" id="swipeZone" *ngIf="!isModal">
  <div class="closed-zone__line"></div>
</div>
<ion-content class="product-card-container" [class.product-card-container-image-enlarged]="enlargedImages" *ngIf="!isModal">
  <!-- ============ HEADER =========== -->
  <ng-container *ngTemplateOutlet="cardHeader"></ng-container>
  <!-- ============ BODY =========== -->
  <ng-container *ngTemplateOutlet="cardBody"></ng-container>
  <!-- ============ FOOTER =========== -->
  <ng-container *ngTemplateOutlet="cardFooter"></ng-container>
  <ng-container>
    <div class="throttling-wrap" *ngIf="restaurant.isOrderThrottling && chosenVariation?.throttlingEstimation">
      <span class="material-icons icon-color">warning</span>
      Wait time for this item is longer than usual (Estimated &nbsp;{{chosenVariation?.throttlingEstimation}})
    </div>
  </ng-container>
</ion-content>

<!-- ============ CARD HEADER TEMPLATE =========== -->
<ng-template #cardHeader>
  <div class="product-container__header"
       [class.product-container__header-image-enlarged]="enlargedImages">
    <app-product-details
      [product]="defaultProduct"
      [chosenVariation]="chosenVariation"
      [hasAllBorderRadius]="true"
      [truncateLength]="truncateDescriptionLength"
      [enforceInventory]="isUseInventory"
      [hoursOfOperation]="hoursOfOperation"
      [currencySign]="currencySign"
      [enlargedImage]="restaurant?.enlargeProductImages"
      [hidePrice]="true"
      [restaurant]="restaurant"
    >
    </app-product-details>
    <div class="dietary-wrap" *ngIf="chosenVariation?.dietary_labels_enabled">
      <ng-container *ngFor="let dietary of dietaryLabels">
        <div class="dietary-container" *ngIf="chosenVariation.dietary_labels[dietary.key]">
          <img class="dietary-icon" [src]="dietary.imgUrl" alt="">{{dietary.title}}
        </div>
      </ng-container>
    </div>
    <p class="product-details__price" *ngIf="isShowPrice(product)">
        <span class="product-container__header-price">
          {{currencySign}}{{getFormattedPrice(cartProduct.item.totalItemPrice.formattedAmount, cartProduct.item.quantity)}}
        </span>
    </p>
  </div>
  <div id="close-modal-x" (click)="closeModal()" class="header-close" *ngIf="isModal">
    <svg slot="icon-only" class="header-close-icon" aria-label="Close">
      <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
    </svg>
  </div>
</ng-template>

<!-- ============ CARD BODY TEMPLATE =========== -->
<ng-template #cardBody>
  <div class="product-container__body"
       [class.product-container__body-image-enlarged]="enlargedImages && isModal"
       [class.product-card-container-image-enlarged]="enlargedImages && !isModal">
    <div class="product-container__body-variations" *ngIf="!isOnlyOneVariation">
      <div class="product-container__body-group-title">
        Choose variation - <span class="product-container__body-group-title-required-status">Required</span>
        <span class="product-container__body-group-title-error-status">&#160;{{variationsInvalidMessage}}</span>
      </div>
      <form>
        <ion-list lines="none" class="product-container__body-list">
          <ion-radio-group>
            <ion-item class="product-container__body-list-item" no-lines
                      *ngFor="let variation of getFilteredVariations(product.variations); index as i"
                      [disabled]="!allowOrder || allowSoldOutOrders(isApplyVariationInStock(variation), variation)">
              <ion-label
                class="product-container__body-list-item-label"
                [color]="isActiveVariation(variation) ? 'brand' : 'main-dark'">
                {{cleanedName(variation.name)}}
                <span>({{currencySign}}{{getFormattedPrice(variation.price.amount /100)}})</span>
                <span class="product-container__body-list-item-unavailable" *ngIf="isApplyVariationInStock(variation)">
                  &nbsp;{{restaurant.enableSoldOutOrders ? 'Future order available' : 'UNAVAILABLE'}}
                </span>
              </ion-label>
              <ion-radio [value]="variation"
                         [checked]="isActiveVariation(variation)"
                         (ionSelect)="chooseVariation($event.target.value)"
                         mode="md"
                         slot="start"
                         color="brand"
                         class="product-container__body-list-item-radio">
              </ion-radio>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </form>
    </div>
    <!-- ============ MODIFIERS =========== -->
    <div class="product-container__body-modifiers"
         *ngFor="let modifierGroup of product.modifierGroups; index as modifiersListIndex"
         [hidden]="formatDataService.containsKeyword(modifierGroup.name, 'HIDDEN')
         || isModifiersHidden(modifierGroup.modifiers) || modifierGroup.hiddenFromCustomer || checkCustomModifiersGroup(modifierGroup)">
      <div class="product-container__body-group-title" id="modifier {{modifierGroup.id}}">
        {{cleanedName(modifierGroup.name)}} - <span class="product-container__body-group-title-required-status">{{formatModifierGroupRequiredStatus(modifierGroup)}}</span>
        <span class="product-container__body-group-title-error-status" *ngIf="!validateItemModifiers(modifierGroup) && showInvalid">&#160;(please select a valid option)</span>
      </div>
      <div *ngIf="modifierGroup.selectionType === 'MULTIPLE' && !isSelectOneModifier(modifierGroup)">
        <ion-list lines="none" class="product-container__body-list">
          <ion-item class="product-container__body-list-item"
                    *ngFor="let modifier of modifierGroup.modifiers; index as modifierIndex"
                    [disabled]="!allowOrder || !isSelectedProductInStock(product)"
                    [hidden]="formatDataService.containsKeyword(modifier.name, 'HIDDEN') || !modifier.isShow">
            <ion-label
              class="product-container__body-list-item-label"
              [color]="isChosenModifier(modifiersListIndex, modifierIndex) ? 'brand' : 'main-dark'">
              {{cleanedName(modifier.name)}}
              <span *ngIf="modifier.price.amount > 0">
                  (+ {{currencySign}}{{getFormattedPrice(modifier.price.amount / 100,1,true)}})
                </span>
            </ion-label>
            <ion-checkbox
              class="product-container__body-list-item-checkbox"
              color="brand"
              slot="start"
              mode="md"
              [checked]="isChosenModifier(modifiersListIndex, modifierIndex) || (modifier.onByDefault && modifier.isSelected && !isEdit)"
              (ionChange)="chooseModifier($event, modifiersListIndex, modifierIndex)"
              [disabled]='isModifierAllow(modifierGroup) && (!modifier.isSelected || modifier.soldOut)'
            >
            </ion-checkbox>
            <div class="slider" *ngIf="formatDataService.containsKeyword(modifier.name, 'SLIDER')">
              <mat-slider [disabled]="!isChosenModifier(modifiersListIndex, modifierIndex)" min="1" max="3" step="1" value="2" (input)="modifierSliderChoose($event.value, modifiersListIndex, modifierIndex)"></mat-slider>
              <span class="slider__param">{{isChosenModifier(modifiersListIndex, modifierIndex) ? findModifierSliderParam(modifier) : ""}}</span>
            </div>
            <div *ngIf="modifier.soldOut" class="modifier-soldout">Sold out</div>
          </ion-item>
        </ion-list>
      </div>
      <div *ngIf="isSelectOneModifier(modifierGroup)">
        <ion-list lines="none" class="product-container__body-list">
          <ion-radio-group>
            <ion-item class="product-container__body-list-item" no-lines
                      *ngFor="let modifier of modifierGroup.modifiers; index as modifierIndex"
                      [disabled]="!allowOrder || !isSelectedProductInStock(product)"
                      [hidden]="formatDataService.containsKeyword(modifier.name, 'HIDDEN')
                      && modifierGroup.modifiers.length > 1 || !modifier.isShow">
              <ion-label
                class="product-container__body-list-item-label"
                [color]="isChosenModifier(modifiersListIndex, modifierIndex) || (modifier.isSelected && !isEdit) ? 'brand' : 'main-dark'">
                {{cleanedName(modifier.name)}}
                <span *ngIf="modifier.price.amount > 0">
                    (+ {{currencySign}}{{getFormattedPrice(modifier.price.amount / 100)}})
                </span>
              </ion-label>
              <ion-radio
                class="product-container__body-list-item-radio"
                color="brand"
                slot="start"
                mode="md"
                [checked]="isChosenModifier(modifiersListIndex, modifierIndex) || (modifier.isSelected && !isEdit)"
                [disabled]="modifier.soldOut"
                (ionSelect)="chooseAndRemoveModifiers($event, modifiersListIndex, modifierIndex, modifier)">
              </ion-radio>
              <div class="slider" *ngIf="formatDataService.containsKeyword(modifier.name, 'SLIDER')">
                <mat-slider [disabled]="!isChosenModifier(modifiersListIndex, modifierIndex)" min="1" max="3" step="1" value="2" (input)="modifierSliderChoose($event.value, modifiersListIndex, modifierIndex)"></mat-slider>
                <span class="slider__param">{{isChosenModifier(modifiersListIndex, modifierIndex) ? findModifierSliderParam(modifier) : ""}}</span>
              </div>
              <div *ngIf="modifier.soldOut" class="modifier-soldout">Sold out</div>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </div>
    </div>
    <div class="product-container__body-variations" *ngIf="chosenVariation?.allowCustomNote">
      <div class="product-container__body-group-title">
        Special Instructions
      </div>
      <ion-item class="product-container__body-area-item">
        <textarea
          id="specialInstructionField"
          class="product-container__body-area-item-textarea"
          placeholder="Enter message"
          (input)="changeSpecialInstructions()"
          maxlength="490"
          rows="8"
          autoGrow="true"
          [(ngModel)]="specialInstructions">
        </textarea>
      </ion-item>
    </div>
    <div class="product-card-container__body-variations" *ngIf="isApplyEnforce(product) && this.isSgtPepps">
      <div class="product-container__body-group-title">
        Quantity - <span class="product-container__body-group-title-required-status">Required</span>
        <ng-container>
          <div class="product-card-container__footer-counter">
            <button (click)="changeQuantity(false)" class="product-card-container__footer-counter-btn">-</button>
            <div class="product-card-container__footer-counter-quantity">{{cartProduct && cartProduct.item.quantity}}</div>
            <button (click)="changeQuantity(true)" class="product-card-container__footer-counter-btn">+</button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- ============ FOOTER TEMPLATE =========== -->
<ng-template #cardFooter>
  <div class="{{isModal ? 'product-container__footer' : 'product-card-container__footer'}}" slot="fixed">
    <ng-container *ngIf="(isApplyEnforce(product) && !this.isSgtPepps)
    || !allowSoldOutOrders(isAddButtonDisabled(product), product.variations)">
      <div class="product-container__footer-counter" *ngIf="!product.isService && !isModifierSoldOut(product)">
        <button (click)="changeQuantity(false)" class="product-container__footer-counter-btn">-</button>
        <div class="product-container__footer-counter-quantity">{{quantity}}</div>
        <button (click)="changeQuantity(true)" class="product-container__footer-counter-btn">+</button>
      </div>
    </ng-container>
    <div class="product-container__footer-wrapper-button">
      <button
        class="product-container__footer-button"
        [class.product-container__footer-button-centered]="this.isSgtPepps"
        (click)="addItemToCart(cartProduct, product)"
        [disabled]="!allowOrder || allowSoldOutOrders(isAddButtonDisabled(product), product.variations) || isModifierSoldOut(product)">
          <span>
            {{addToCartButtonText(product)}}
          </span>
        <span *ngIf="isShowPrice(product) && !this.isSgtPepps">
            {{currencySign}}{{getFormattedPrice(cartProduct.item.totalItemPrice.formattedAmount, cartProduct.item.quantity)}}
        </span>
      </button>
    </div>
  </div>
</ng-template>
